import React from 'react';
import { LucideIcon } from 'lucide-react';

interface ButtonProps {
  onClick?: () => void;
  type?: 'button' | 'submit';
  children: React.ReactNode;
  className?: string; // Additional className
  variant?: 'primary' | 'secondary' | 'ghost' | 'success' | 'danger'; // Button variants
  disabled?: boolean;
  isLoading?: boolean;
  icon?: LucideIcon;
  iconPosition?: 'left' | 'right';
}

const Button: React.FC<ButtonProps> = ({
  onClick,
  type = 'button',
  children,
  className,
  variant = 'primary',
  disabled = false,
  isLoading = false,
  icon: Icon,
  iconPosition = 'left',
}) => {
  const baseClasses = '';

  // Define classes for each button variant
  const variantClasses: Record<string, string> = {
    primary:   'cg-btn cg-btn-primary',
    secondary: 'cg-btn cg-btn-ghost',
    ghost:     'cg-btn cg-btn-ghost',
    success:   'cg-btn cg-btn-primary',
    danger:    'cg-btn cg-btn-danger',
  };

  const renderContent = () => {
    if (isLoading) {
      return (
        <div className="flex items-center justify-center">
          {children}
          <span className="ml-2 spinner-border animate-spin inline-block w-4 h-4 border-2 rounded-full border-t-white" />
        </div>
      );
    }

    return (
      <>
        {Icon && iconPosition === 'left' && <Icon className="w-4 h-4 mr-2" />}
        {children}
        {Icon && iconPosition === 'right' && <Icon className="w-4 h-4 ml-2" />}
      </>
    );
  };

  // Apply base classes, variant classes, and additional className
  return (
    <button
      type={type}
      onClick={onClick}
      className={`${baseClasses} ${variantClasses[variant] || variantClasses.primary} ${className || ''}`}
      disabled={disabled}
    >
      {renderContent()}
    </button>
  );
};

export default Button;
